import { useMemo, useState } from 'react';
import { hotCategories, hotChart } from '@/mocks/homeData';

export default function TopChart() {
  const [active, setActive] = useState('全部');

  const list = useMemo(
    () => (active === '全部' ? hotChart : hotChart.filter((item) => item.category === active)),
    [active],
  );

  return (
    <section id="top-chart" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-primary-600 text-xs md:text-sm font-label font-medium tracking-wide">
              <i className="ri-fire-line" />
              热门榜 / TOP榜
            </p>
            <h2 className="mt-3 font-heading font-bold text-foreground-950 text-2xl md:text-4xl leading-snug">
              先看这些：按讨论热度实时排序的榜单
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              榜单把站内收录的条目按热度与收录次数综合排列。想快速挑最炸的一条，直接看前十即可。
            </p>
          </div>

          <div className="flex flex-wrap gap-1 p-1 rounded-full bg-background-100 border border-background-200 shrink-0">
            {hotCategories.map((cat) => (
              <button
                key={cat}
                type="button"
                onClick={() => setActive(cat)}
                className={`px-3.5 py-1.5 rounded-full text-xs md:text-sm font-label cursor-pointer transition-colors whitespace-nowrap ${
                  active === cat
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-9 border-t border-background-200">
          {list.map((item) => (
            <a
              key={item.id}
              href="#must-read"
              className="group grid grid-cols-[48px_1fr] md:grid-cols-[72px_1fr_auto] items-start md:items-center gap-4 md:gap-6 py-5 border-b border-background-200 cursor-pointer transition-colors hover:bg-background-100/70 px-2 md:px-3 -mx-2 md:-mx-3 rounded-md"
            >
              <span
                className={`font-heading font-black text-2xl md:text-4xl leading-none ${
                  item.rank <= 3 ? 'text-primary-500' : 'text-background-400'
                }`}
              >
                {String(item.rank).padStart(2, '0')}
              </span>

              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] md:text-xs font-label">
                    {item.category}
                  </span>
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-[11px] md:text-xs font-label">
                    {item.badge}
                  </span>
                </div>
                <h3 className="mt-2 font-heading font-semibold text-foreground-950 text-base md:text-xl leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>

              <div className="col-span-2 md:col-span-1 flex items-center md:flex-col md:items-end gap-2 md:gap-1 md:pl-6">
                <span className="flex items-center gap-1 font-heading font-bold text-primary-600 text-sm md:text-lg">
                  <i className="ri-fire-line" />
                  {item.heat}
                </span>
                <span className="text-foreground-400 text-xs font-label">讨论热度</span>
                <i className="ml-auto md:ml-0 ri-arrow-right-line text-foreground-300 group-hover:text-primary-500 transition-colors" />
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <a
            href="#index"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-foreground-200 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看完整 TOP榜 索引
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}